import { type ReactNode } from "react";
import { Link, type LinkProps } from "react-router-dom";

type SectionLinkProps = {
  /** Router destination. */
  to: LinkProps["to"];
  /** Link label (e.g. "See all"). */
  children: ReactNode;
};

/**
 * The canonical action link shown beside a {@link SectionTitle} — bold,
 * underlined, DS-primary. Shared across Discovery, Room and Profile sections so
 * every "See all" affordance stays visually aligned.
 */
function SectionLink({ to, children }: SectionLinkProps): React.JSX.Element {
  return (
    <Link
      to={to}
      className="font-dm-sans shrink-0 text-xs font-bold tracking-wide text-ds-primary underline"
    >
      {children}
    </Link>
  );
}

export { SectionLink, type SectionLinkProps };
